export enum USER_INPUT_FILTER_COMPONENT_TYPE {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTI_CHOICE = 'MULTI_CHOICE',
  CHECKBOX = 'CHECKBOX',
  RANGE_SLIDER = 'RANGE_SLIDER',
}
